import React, { Component } from 'react'
import classnames from 'classnames'
import numeral from 'numeral'
import { get } from 'lodash/object'
import { Div } from '@driftt/tide-core'
import { roundPercentValue } from 'components/Reports/EmailPerformance/utils'

class StatTabs extends Component {
  getClassNames(activeTab) {
    const defaultClass = 'email-performance-stat-tab'
    return {
      enrolledClass: classnames(defaultClass, {
        'email-performance-stat-tab-enrolled--active  active-tab': activeTab === 'TOTAL_ENROLLED'
      }),
      clickClass: classnames(defaultClass, {
        'email-performance-stat-tab-clicks--active  active-tab': activeTab === 'TOTAL_CLICKS'
      }),
      lostClass: classnames(defaultClass, {
        'email-performance-stat-tab-loss--active active-tab': activeTab === 'TOTAL_LOSS'
      }),
      conversationClass: classnames(defaultClass, {
        'email-performance-stat-tab-conversations--active active-tab': activeTab === 'TOTAL_CONVERSATIONS'
      }),
      dollarsClass: classnames(defaultClass, {
        'email-performance-stat-tab-dollars--active active-tab': activeTab === 'TOTAL_DOLLARS',
        'dollars-tab': true
      })
    }
  }

  getTotalValues(total) {
    const {
      playbookReportType = 'email',
    } = this.props

    if (playbookReportType === 'email') {
      return {
        clicked: Number(get(total, 'CLICKED.value', 0)),
        lost: Number(get(total, 'BOUNCED.value', 0)) + Number(get(total, 'UNSUBSCRIBED.value', 0)),
        inprogress: Number(get(total, 'ENROLLED.value', 0)),
        conversations: Number(get(total, 'CONVERSATION_INFLUENCED.value', 0)) + Number(get(total, 'MEETING_INFLUENCED.value', 0)) + Number(get(total, 'REPLIED.value', 0)),
      }
    } else {
      // signature
      return {
        clicked: Number(get(total, 'CLICKED.value', 0)),
        conversations: Number(get(total, 'CONVERSATION_INFLUENCED.value', 0)),
      }
    }
  }

  renderTabHeader(wrapperClass, value, switchTabName, title, conversionRate) {
    const {
      switchTab
    } = this.props

    if (value === undefined)
      return null

    return (
      <Div className={wrapperClass} onClick={() => { switchTab(switchTabName)}}>
        <Div className="email-performance-stat-label">
          {title}
        </Div>
        <Div className="email-performance-stat-value">
          {value}
        </Div>
        <Div className="email-performance-stat-value-pullout">
          {conversionRate}
        </Div>
      </Div>
    )
  }

  render() {
    const { activeTab, switchTab, data, salesForceRevenue, totalSalesForceDollars, reportType, playbookReportType, isCampaign } = this.props
    const { enrolledClass, clickClass, lostClass, conversationClass, dollarsClass } = this.getClassNames(activeTab)
    const total = data.total
    const VALUES = this.getTotalValues(total)
    const isEmailReport = playbookReportType === 'email'
    const isOldEmailPlaybook = (reportType === 'SEND_A_ONETIME_EMAIL' || reportType === 'SEND_AN_AUTOMATED_EMAIL')
    const baseValue = reportType === 'OUTBOUND_SEQUENCE' ? get(total, ['SENT', 'value'], 0): get(total, ['DELIVERED', 'value'], 0)
    
    const clickThroughRate = roundPercentValue(total.CLICKED.value, baseValue)
    const lostPercentage = roundPercentValue(VALUES.lost, VALUES.inprogress)
    const conversationsPercentage = roundPercentValue(VALUES.conversations, baseValue)

    const tabGroupClass = classnames('email-performance-stat-tab-group', {
      'email-performance-stat-tab-group-salesforce': salesForceRevenue
    })
    const hideSFTab = window.localStorage.getItem('hideEmailSFNumbers') | isCampaign

    return (
      <Div className={tabGroupClass}>
        {this.renderTabHeader(enrolledClass, VALUES.inprogress, 'TOTAL_ENROLLED', 'Total enrolled')}
        {this.renderTabHeader(clickClass, VALUES.clicked, 'TOTAL_CLICKS', 'Total clicks', `(Click-through rate - ${clickThroughRate}%)`)}
        {!isOldEmailPlaybook && this.renderTabHeader(conversationClass, VALUES.conversations, 'TOTAL_CONVERSATIONS', 'Total conversations', `(${conversationsPercentage}%)`)}
        {this.renderTabHeader(lostClass, VALUES.lost, 'TOTAL_LOSS', 'Total lost', `(${lostPercentage}%)`)}
        {!hideSFTab && !isOldEmailPlaybook && isEmailReport &&
          <Div className={dollarsClass} onClick={() => {switchTab('TOTAL_DOLLARS')}}>
            <Div className="email-performance-stat-label">
              Total $ influenced
            </Div>
            <Div className="email-performance-stat-value">
              {`${salesForceRevenue ? numeral(totalSalesForceDollars).format('($0a)') : '?'}`}
            </Div>
            <Div className="email-performance-stat-value-pullout">
            </Div>
          </Div>
        }
      </Div>
    )
  }
}

export default StatTabs
